import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common'; // Import CommonModule
import { ReactiveFormsModule } from '@angular/forms';
import { BlockTextComponent } from '../../../common/block-text/block-text.component';
import {
  ConciergeInitModel,
  ConciergeInitVariables,
  ConciergeModel,
  ConciergeVariables,
} from '../../../../../models/email-template/concierge.interface';
import { BaseComponent } from '../../../common/BaseComponent';
import { NotificationComponent } from '../../../common/notification/notification.component';
import { PinComponent } from '../../../common/pin/pin.component';
import { Helper } from '../../../../../utils/helper';

@Component({
    selector: 'app-concierge',
    imports: [
        CommonModule,
        ReactiveFormsModule,
        BlockTextComponent,
        NotificationComponent,
        PinComponent,
    ],
    templateUrl: './concierge.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './concierge.component.scss'
})
export class ConciergeComponent extends BaseComponent implements OnInit {
  @Input() block: ConciergeModel = new ConciergeInitModel();
  @Input() isPreview = false;
  @Output() blockData = new EventEmitter<any>();
  @Output() removeBlockEvent = new EventEmitter<string | null>();

  ngOnInit() {
    if (Helper.isEmpty(this.block.variables!)) {
      this.block.variables = new ConciergeInitVariables()
    }
  }

  //placeholders:
  headingPlaceholder: string = 'Enter Heading Text';
  textPlaceholder: string = 'Enter Text';
  imagePlaceholder: string = 'Image';
  hrefPlaceholder: string = 'Enter Image Redirect Link';
  altPlaceholder: string = 'Enter Image Alt';

  removeBlock(): void {
    this.removeBlockEvent.emit(this.block.blockId); // Emit the ID to parent
  }

  onChange(value: any, fieldName: keyof ConciergeVariables) {
    if (this.block.variables) {
      this.block.variables[fieldName] = value;
      this.blockData.emit(this.block);
    }
  }

  onContainerClick(event: MouseEvent) {
    // Forward the click event to the child app-pin component
    this.pinComponent.onContainerClick(event);
  }

  handleOnSegmentChange(segment: string, blockName: string) {
    if (this.block.variables) {
      this.block.variables[blockName as keyof ConciergeVariables] = segment;
      this.blockData.emit(this.block);
    }
    return;
  }
}
